// SPDX-License-Identifier: AGPL-3.0-or-later

export const SOUNDBOARD_SOUND_PATH_PREFIX = 'soundboard-sounds';
export const SOUNDBOARD_SOUND_MAX_BYTES = 3 * 1024 * 1024;
export const SOUNDBOARD_SOUND_MAX_DURATION_MS = 120_000;
export const SOUNDBOARD_SOUND_MIN_DURATION_MS = 100;
export const SOUNDBOARD_SOUND_NAME_MAX_LENGTH = 32;
export const SOUNDBOARD_SOUND_VOLUME_MAX = 100;
export const SOUNDBOARD_SOUND_VOLUME_DEFAULT = 100;
